module.exports = __webpack_public_path__ + "assets/img/MACD形态条件.a6204347.png";